type Props = {
  text: string;
  match: string;
};

const HighlightMatch = (props: Props) => {
  const { text, match } = props;

  const safeMatch = match.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  // This ensures that match is treated as a plain string rather than a regex pattern
  const parts = text.split(new RegExp(`(${safeMatch})`, 'gi'));

  return (
    <span>
      {' '}
      {parts.map((part, index) =>
        part?.toLowerCase() === match?.toLowerCase() ? (
          <span key={index} className="font-bold">
            {part}
          </span>
        ) : (
          part
        ),
      )}{' '}
    </span>
  );
};

export default HighlightMatch;
